import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import FAQ from '../../icons/FAQ';
import History from '../../icons/History';

export default function CashoutHeader() {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div className="member-diamonds-subheader row">
      <div className="col-xs-12">
        <div className="member-diamonds-subheader-menu">
          <span>{t('cashout_cash_out')}</span>
          <div className="member-diamonds-subheader-menu-items">
            <Link to="/educate" className="member-diamonds-to-cash-more-item">
              <FAQ />
            </Link>
            <Link to="/history" className="member-diamonds-to-cash-more-item member-diamonds-to-cash-more-item-history">
              <History />
            </Link>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
